<template>
    <div class="card border-0 h-100 product-card bg-white rounded-4 overflow-hidden">
        <div class="position-relative" style="height: 280px;">
            <!-- Sale Badge -->
            <span v-if="product.old_price > product.price" 
                  class="badge bg-danger position-absolute top-0 start-0 z-2 d-flex align-items-center justify-content-center"
                  style="border-radius: 16px 0 16px 0; min-width: 80px; height: 32px; font-size: 0.8rem;">
                  SALE {{ product.discount_percentage }}%
            </span>

            <!-- Heart Icon -->
            <div class="position-absolute top-0 end-0 p-3 z-2">
                <div class="bg-white rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                     style="width: 32px; height: 32px; cursor: pointer;"
                     @click.prevent="toggleFavorite">
                     <i class="bi" :class="product.isFavored ? 'bi-heart-fill text-danger' : 'bi-heart'"></i>
                </div>
            </div>
            
            <a :href="'/product/' + product.id" class="text-decoration-none d-block w-100 h-100">
                <img :src="product.default_image.large"
                     class="w-100 h-100 object-fit-cover transition-transform" 
                     :alt="product.name">
            </a>
        </div>
             
        <div class="card-body p-3 pt-4">
            <a :href="'/product/' + product.id" class="text-decoration-none text-dark">
                <h6 class="card-title fw-bold text-truncate mb-1" :title="product.name">{{ product.name }}</h6>
            </a>
            
            <div class="mb-2 text-warning small">
                <!-- Simple star representation or use a component -->
                <i class="bi bi-star-fill"></i>
                <i class="bi bi-star-fill"></i>
                <i class="bi bi-star-fill"></i>
                <i class="bi bi-star-fill"></i>
                <i class="bi bi-star-fill"></i>
                <span class="text-muted ms-1">({{ product.reviews_count || 0 }})</span>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <span class="fw-bold text-brown fs-5">EGP {{ product.price }}</span>
                    <span v-if="product.old_price > product.price" class="text-muted text-decoration-line-through small ms-1">EGP {{ product.old_price }}</span>
                </div>
                <button class="btn btn-brown rounded-circle btn-sm d-flex align-items-center justify-content-center" 
                        style="width: 32px; height: 32px;"
                        @click="$emit('add-to-cart', product)">
                    <i class="bi bi-plus text-white fs-5"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    methods: {
        toggleFavorite() {
            // Check auth globally or redirect
            // Assuming we rely on 401 response or global auth check
            
            axios.post(`/api/frontend/toggleFavored/${this.product.id}`)
                .then(response => {
                    this.product.isFavored = !this.product.isFavored;
                    // Emit event for Navbar to update count
                    window.Bus.$emit('wishlist-updated');
                    
                    if (this.product.isFavored) {
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Added to Wishlist!',
                            text: 'Product has been added to your favorites.',
                            timer: 2000,
                            showConfirmButton: false,
                            toast: true,
                            position: 'top-end'
                        });
                    } else {
                        this.$swal.fire({
                            icon: 'info',
                            title: 'Removed from Wishlist',
                            text: 'Product has been removed from your favorites.',
                            timer: 2000,
                            showConfirmButton: false,
                            toast: true,
                            position: 'top-end'
                        });
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status === 401) {
                         window.location.href = '/customer/login';
                    }
                    console.error('Error toggling favorite:', error);
                });
        }
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
.product-card {
    transition: transform 0.2s;
}
.transition-transform {
    transition: transform 0.3s ease;
}
.product-card:hover .transition-transform {
    transform: scale(1.05);
}
.product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}
</style>
